import { render, staticRenderFns } from "./FlowEditorTurnOffArea.vue?vue&type=template&id=085190da&"
import script from "./FlowEditorTurnOffArea.vue?vue&type=script&lang=js&"
export * from "./FlowEditorTurnOffArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports